import React from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { formatCAD } from "@/lib/format";
import SafeImage from "@/components/SafeImage";

/** Compact product card optimized for dense grids and carousels. */
export default function ProductCardCompact({ product, className = "" }) {
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-c-${product.product_id}`}
      className={`group block surface overflow-hidden hover:shadow-md transition-shadow ${className}`}
    >
      <div className="aspect-square overflow-hidden bg-[#F3F2F0] relative">
        <SafeImage
          src={product.featured_image || product.images?.[0]}
          alt={product.name}
          className="product-card-img w-full h-full object-cover"
        />
        {product.compare_price && product.compare_price > product.price && (
          <span className="absolute top-2 left-2 tag-pill bg-[#702A32] text-white">
            -{Math.round(((product.compare_price - product.price) / product.compare_price) * 100)}%
          </span>
        )}
        {product.product_type === "POD" && (
          <span className="absolute top-2 right-2 tag-pill bg-white/95 text-[#2A4B3A]">POD</span>
        )}
      </div>
      <div className="p-3">
        <h3 className="text-sm leading-snug text-[#1A1A18] line-clamp-2 min-h-[2.5em]">{product.name}</h3>
        <div className="flex items-center gap-1 mt-1 text-xs text-[#8A8782]">
          <Star className="w-3 h-3 fill-[#C78B1B] text-[#C78B1B]" strokeWidth={1.5} />
          <span>{product.rating?.toFixed(1) || "—"}</span>
          <span>({product.review_count})</span>
        </div>
        <div className="flex items-baseline gap-1.5 mt-1">
          <span className="font-mono text-base text-[#1A1A18]">{formatCAD(product.price)}</span>
          {product.compare_price && product.compare_price > product.price && (
            <span className="font-mono text-xs text-[#8A8782] line-through">{formatCAD(product.compare_price)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
